// Vendores
import React from "react";
import { ThemeIcon, UnstyledButton, Group, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { NavLink, useLocation } from "react-router-dom";
import {
  IconLayoutDashboard,
  IconUsers,
  IconUser,
  IconForms,
  IconSpeakerphone,
  IconMasksTheater,
} from "@tabler/icons";

import { useDispatch } from "react-redux";
import { toggleNavListState } from "../../redux/reducers/theme";

function MainLink({ icon, color, label, link }) {
  const location = useLocation();
  const sm = useMediaQuery("(max-width: 800px)");

  const dispatch = useDispatch();
  return (
    <NavLink
      to={link}
      style={{
        textDecoration: "none",
        maxWidth: "150px",
      }}
    >
      <UnstyledButton
        onClick={sm ? () => dispatch(toggleNavListState()) : null}
        sx={(theme) => ({
          display: "block",
          width: "100%",
          padding: theme.spacing.xs,
          borderRadius: theme.radius.sm,
          color:
            theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
          borderLeft: "5px solid",
          borderColor: "#0000",
          ":hover": {
            backgroundColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[6]
                : theme.colors.gray[0],
            // borderColor: "#eeaa80",
          },
          ...(location.pathname.startsWith(link)
            ? {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[6]
                    : theme.colors.gray[0],
                borderColor: "#ffc515",
              }
            : {}),
        })}
      >
        <Group>
          <ThemeIcon color={color} variant="light">
            {icon}
          </ThemeIcon>

          <Text size="sm">{label}</Text>
        </Group>
      </UnstyledButton>
    </NavLink>
  );
}

export default function MainLinks() {
  const user = JSON.parse(localStorage.getItem("userInfo"));
  let data;
  if (user?.privileges !== "ADMIN") {
    data = [
      {
        icon: <IconLayoutDashboard size={16} />,
        label: "Report",
        link: "/app/dashboard",
      },
      {
        icon: <IconSpeakerphone size={16} />,
        label: "Events",
        link: "/app/events",
      },

      { icon: <IconForms size={16} />, label: "Forms", link: "/app/forms" },

      { icon: <IconUser size={16} />, label: "Profile", link: "/app/profile" },
    ];
  } else {
    data = [
      {
        icon: <IconLayoutDashboard size={16} />,
        label: "Report",
        link: "/app/dashboard",
      },
      {
        icon: <IconSpeakerphone size={16} />,
        label: "Events",
        link: "/app/events",
      },
      { icon: <IconForms size={16} />, label: "Forms", link: "/app/forms" },
      {
        icon: <IconMasksTheater size={16} />,
        label: "Theater",
        link: "/app/theater",
      },

      { icon: <IconUsers size={16} />, label: "Users", link: "/app/users" },
      { icon: <IconUser size={16} />, label: "Profile", link: "/app/profile" },
    ];
  }
  const links = data.map((link) => <MainLink {...link} key={link.label} />);
  return <div>{links}</div>;
}
